import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { deleteUser } from '../../routing/routes';

const ListUsers = ({ users, user, permisos, setNotification, refreshData }) => {
	const history = useHistory();
	const [localUsers, setLocalUsers] = useState(users.filter((x) => x._id !== user._id));

	useEffect(() => {
		setLocalUsers(users.filter((x) => x._id !== user._id));
	}, [users, user]);

	return (
		<div>
			<div>
				<h2 style={{ textAlign: 'center' }}> Usuario Actual </h2>
				<hr style={{ width: '50%', marginBottom: '20px' }} />
				<div align='center'>
					<h3
						className='usersList'
						align='center'
						onClick={() => {
							history.push('/users/edit/' + user._id);
						}}
					>
						{user.username}
					</h3>
				</div>

				<h2 style={{ textAlign: 'center' }}> Usuarios Registrados </h2>
				<hr style={{ width: '50%', marginBottom: '20px' }} />
				{localUsers.map((data) => (
					<UserVisualizer
						user_data={data}
						key={data.username}
						history={history}
						permisos={permisos}
						setNotification={setNotification}
						refreshData={refreshData}
					/>
				))}
			</div>
			{permisos.crearUsuarios && (
				<div>
					<button
						className='floatingButton'
						onClick={() => {
							history.push('/users/new');
						}}
					>
						+
					</button>
				</div>
			)}
		</div>
	);
};

const UserVisualizer = ({ user_data, history, permisos, setNotification, refreshData }) => {
	return (
		<div align='center'>
			<h3
				className='usersList'
				align='center'
				onClick={() => {
					permisos.modificarUsuarios && history.push('/users/edit/' + user_data._id);
				}}
			>
				{user_data.username}
			</h3>
			{permisos.eliminarUsuarios && (
				<button
					onClick={() => {
						deleteUser(user_data)
							.catch((error) => {
								console.error('Error:', error);
								setNotification('eError al eliminar el usuario');
								history.push('/users');
							})
							.then(() => {
								refreshData();
								setNotification('mUsuario eliminado correctamente');
								history.push('/users');
							});
					}}
					className='remove-button'
				>
					x
				</button>
			)}
		</div>
	);
};

export default ListUsers;
